import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import { Form, Row, Col } from "react-bootstrap";

const ForgetPassword = () => {
    return (
        <div className="Login_sec">
            <Container>
                <Row className="justify-content-center">
                    <Col lg={6}>
                        <div className="login_form">
                            <div className="login_user">
                                <span><i class="bi bi-person-fill"></i></span>
                                <h5>Forget Password</h5>
                            </div>
                            <Form>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Email </Form.Label>
                                    <Form.Control type="email" placeholder="Enter email" />
                                </Form.Group>
                                
                                <div className="login_btn">
                                    <a href="/newpassowrd">Submit</a>
                                </div>
                            </Form>
                            <div className="other_sign forget_div">
                                <h6>Still no account? <a href="/register">Sign up</a></h6>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ForgetPassword;
